import { render, staticRenderFns } from "./SupervisorSettings.vue?vue&type=template&id=522bd893&scoped=true&"
import script from "./SupervisorSettings.vue?vue&type=script&lang=js&"
export * from "./SupervisorSettings.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorSettings.vue?vue&type=style&index=0&id=522bd893&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522bd893",
  null
  
)

export default component.exports